import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";
import "./style.css";

function CustomModal({
  children,
  modalTitle,
  modalClose,
  show,
  darkHeader = false,
  showHeader = true,
  className,
  backdrop = false,
}) {
  const modalHeader = darkHeader ? "modalDarkHeader" : "modalHeader";
  const modalTitleText = darkHeader ? "modalWhiteTitle" : "modalTitle";
  return (
    <Modal
      show={show}
      className={`custom-modal ${className ? className : ""}`}
      onHide={modalClose}
      backdrop={backdrop ? "static" : ""}
    >
      <div className="modalBackdrop">
        {showHeader && (
          <Modal.Header
            className={`${modalHeader} border-0 row mx-0 flex-row align-items-center justify-content-between`}
            closeButton
          >
            <Modal.Title className={`${modalTitleText}`}>
              {modalTitle}
            </Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body className="p-0">{children}</Modal.Body>
      </div>
    </Modal>
  );
}
CustomModal.propTypes = {
  darkHeader: PropTypes.any,
  modalClose: PropTypes.any,
  modalTitle: PropTypes.any,
  children: PropTypes.any,
  showHeader: PropTypes.bool,
  className: PropTypes.string,
  backdrop: PropTypes.bool,
};

export default CustomModal;
